
/*
export default class CartManager {



    static init() {
        this.badge = document.getElementById('cart-badge');
        if (this.badge) {
            this.updateBadge();
        }
        this.bindEvents();

        this.updateBadge();
    }



    static bindEvents() {
        // Vorhandener Code für data-action Buttons
        document.querySelectorAll('[data-action]').forEach(btn => {
            btn.addEventListener('click', e => {
                const productId = btn.dataset.productId;
                const action = btn.dataset.action;
                const quantity = action === 'increment' ? 1 : (action === 'decrement' ? -1 : 0);
                if (quantity !== 0) {
                    this.addToCart(productId, quantity);
                }
            });
        });




        document.querySelectorAll('[data-quantity-input]').forEach(input => {
            input.addEventListener('change', e => this.handleQuantityChange(e.target));
            input.addEventListener('keyup', e => {
                if (e.key === 'Enter') this.handleQuantityChange(e.target);
            });
        });

        document.querySelectorAll('.add-to-cart-button').forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const productId = button.dataset.productId;
                this.addToCart(productId, 1); // Fügt 1 Stück des Produkts hinzu
            });
        });


        document.querySelectorAll('.product-decrement-button, .product-increment-button').forEach(button => {
            button.addEventListener('click', (e) => {
                const wrapper = button.closest('[data-quantity-control]');
                const input = wrapper.querySelector('.product-quantity-input');
                let value = parseInt(input.value);

                if (button.classList.contains('product-decrement-button')) {
                    value = Math.max(value - 1, 1);
                } else {
                    value = Math.min(value + 1, parseInt(input.max));
                }

                input.value = value;
            });
        });


      



        // Vorhandener Code für remove-Buttons
        document.querySelectorAll('.js-remove-cart').forEach(form => {
            form.addEventListener('submit', e => {
                e.preventDefault();
                const productId = form.querySelector('input[name="product_id"]').value;
                this.deleteCartItem(productId, form);
            });
        });
        document.querySelectorAll('.cart-decrement-button, .cart-increment-button').forEach(button => {
            button.addEventListener('click', (e) => {
                const wrapper = button.closest('[data-quantity-control]');
                if (!wrapper) {
                    console.error('Quantity control container nicht gefunden');
                    return;
                }

                const input = wrapper.querySelector('.product-quantity');
                let value = parseInt(input.value);

                if (button.classList.contains('cart-decrement-button')) {
                    value = Math.max(value - 1, 1);
                } else {
                    value = Math.min(value + 1, parseInt(input.max));
                }

                input.value = value;
            });
        });

        // Submit-Button
      // Submit-Button


    }

    static async addToCart(productId, quantity = 1, productName = '') {
        const buttons = document.querySelectorAll(`[data-product-id="${productId}"]`);
        buttons.forEach(btn => btn.disabled = true);
    
        const toast = showToast(`Produkt ${productName} wird hinzugefügt...`, 'loading');
    
        try {
            const response = await fetch(`/cart/add/${productId}`, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ quantity })
            });
    
            const data = await response.json();
            toast.remove();
    
            if (data.success) {
                this.updateBadge();
                this.updateCartItemUI(productId, data.newQuantity, data.newPrice);
                showToast(`Produkt ${productName} wurde erfolgreich hinzugefügt!`, 'success');
                window.dispatchEvent(new Event('cart-updated'));
            } else {
                showToast(data.message || `Fehler beim Hinzufügen von ${productName}!`, 'error');
            }
        } catch (error) {
            toast.remove();
            console.error('Fehler:', error);
            showToast(`Serverfehler beim Hinzufügen von ${productName}!`, 'error');
        } finally {
            buttons.forEach(btn => btn.disabled = false);
        }
    }
    
    static updateCartItemUI(productId, quantity, price) {
        // Direkte DOM Updates
        document.querySelectorAll(`[data-product-id="${productId}"]`).forEach(el => {
            if (el.classList.contains('item-quantity')) {
                el.textContent = quantity;
            }
            if (el.classList.contains('item-total')) {
                el.textContent = `$${price.toFixed(2)}`;
            }
            if (el.hasAttribute('data-quantity-input')) {
                el.value = quantity;
            }

        });
        this.updateTotalPrice();
    }
    static async deleteCartItem(productId, form) {
        const toast = showToast('Produkt wird entfernt...', 'loading');
    
        try {
            const response = await fetch(`/cart/remove`, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ product_id: productId })
            });
    
            const data = await response.json();
            toast.remove();
    
            if (data.success) {
                const article = form.closest('.cart-item');
                if (article) article.remove();
    
                this.updateCartItemUI(productId, data.newQuantity, data.newPrice);
                this.updateBadge();
    
                const quantityEl = document.querySelector(`span[data-product-id="${productId}"][data-quantity-display]`);
                if (quantityEl) quantityEl.textContent = data.newQuantity;
    
                showToast(data.message || 'Artikel entfernt!', 'success');
                window.dispatchEvent(new Event('cart-updated'));
            } else {
                showToast(data.message || 'Fehler beim Entfernen des Artikels!', 'error');
            }
        } catch (error) {
            toast.remove();
            console.error('Fehler:', error);
            showToast('Serverfehler beim Entfernen des Artikels!', 'error');
        }
    }
    
    static async updateBadge() {
         this.badge = document.getElementById('cart-badge');
        if (!this.badge) return;

        try {
            const response = await fetch('/cart/count');
            const data = await response.json();
            this.badge.textContent = data.total;
            this.badge.classList.toggle('hidden', data.total <= 0);
        } catch (error) {
            console.error('Fehler:', error);
        }
    }


    static async handleQuantityChange(input) {
        const productId = input.dataset.productId;
        const newQuantity = parseInt(input.value) || 1;

        try {
            const data = await this.setCartQuantity(productId, newQuantity);
            if (data.success) {
                this.updateCartItemUI(productId, data.newQuantity, data.newPrice);
                showToast('Menge aktualisiert', 'success');
            } else {
                showToast('Ungültige Menge eingegeben', 'error');
            }

        } catch (error) {
            console.error('Fehler:', error);
            showToast('Ungültige Menge eingegeben', 'error');
        }
    }

    static async setCartQuantity(productId, quantity) {
        try {
            const response = await fetch(`/cart/set/${productId}`, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ quantity: quantity })
            });

            const data = await response.json();
            if (data.success) {
                this.updateBadge();
                this.updateCartItemUI(productId, data.newQuantity, data.newPrice);

            }
            return data;
        } catch (error) {
            console.error('Fehler:', error);
            throw error;
        }
    }

    static updateTotalPrice() {
        fetch('/cart/data').then(res => res.json()).then(data => {
            document.querySelectorAll('.total-price').forEach(el => {
                el.textContent = `$${data.totalPrice.toFixed(2)}`;
            });
            document.getElementById('total-item-count').textContent = `${data.totalItems} Artikel insgesamt`;
            document.getElementById('item-count').textContent = `${data.itemCount} verschiedene Artikel`;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => CartManager.init());

*/